"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>BotWithAnimatedBorder_BotWithAnimatedBorder
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_BotWithAnumatedBorder_styles_js_namespaceObject = require("./BotWithAnumatedBorder.styles.js");
const BotWithAnimatedBorder = ({ isMuted, mediaStream })=>{
    const [isSpeaking, setIsSpeaking] = (0, external_react_namespaceObject.useState)(false);
    const [, setAudioContext] = (0, external_react_namespaceObject.useState)(null);
    const [, setAnalyser] = (0, external_react_namespaceObject.useState)(null);
    const stream = mediaStream;
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (stream) {
            const audioCtx = new window.AudioContext();
            const analyserNode = audioCtx.createAnalyser();
            const source = audioCtx.createMediaStreamSource(stream);
            source.connect(analyserNode);
            analyserNode.fftSize = 256;
            const bufferLength = analyserNode.frequencyBinCount;
            const dataArray = new Uint8Array(bufferLength);
            setAudioContext(audioCtx);
            setAnalyser(analyserNode);
            const detectSpeech = ()=>{
                analyserNode.getByteFrequencyData(dataArray);
                const avgVolume = dataArray.reduce((a, b)=>a + b) / bufferLength;
                avgVolume > 10 ? setIsSpeaking(true) : setIsSpeaking(false);
            };
            const intervalId = setInterval(detectSpeech, 100);
            return ()=>{
                clearInterval(intervalId);
            };
        }
    }, [
        stream
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_BotWithAnumatedBorder_styles_js_namespaceObject.Container, {
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_BotWithAnumatedBorder_styles_js_namespaceObject.LogoWrapper, {
            isSpeaking: isSpeaking && !isMuted,
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_BotWithAnumatedBorder_styles_js_namespaceObject.Logo, {
                src: "https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg",
                alt: "Priceline Bot Logo"
            })
        })
    });
};
const BotWithAnimatedBorder_BotWithAnimatedBorder = BotWithAnimatedBorder;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
